import { Box, Typography } from "@mui/material";
import "./_style.scss";
import TkStepper from "../../components/atoms/TkStepper";
import {
  conMid,
  context,
  conTop,
  fakeTableList,
  infoHeadTitleList,
  infoHeadTitleTwoList,
  headListWorkingDayNum,
  spaceArea,
  stepper,
} from "./parts";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkBackButton from "../../components/molecules/TkBackButton";
import { useLocation, useNavigate } from "react-router-dom";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { httpAPI_STA003, httpIAPI_STA008 } from "./api/request";
import TkCheckbox from "../../components/atoms/TkCheckbox";
import TkTable from "../../components/atoms/TkTable";
import {
  funInfoBodyList,
  funInfoBodyTwoList,
  funWorkingDayNumInfoBodyList,
} from "./hooks/useHooks";
import {
  FormClassRetire,
  OtherBenefitsFlg,
  Prefectures,
  RetireFlowReason,
  RetirementInvoiceOrder,
  RetireReason,
  WithholdingSlipKbn,
} from "../../assets/data/Constants";
import { TkGetCode } from "../../utils/TkGetCode";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkButton from "../../components/atoms/TkButton";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import { API_STA008_BuildReqParams } from "../../utils/buildRequestParams";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { changeAmountFormat, changeZipcodeFormat } from "../../utils/useTools";
import { IJob_32Props } from "../../type/contextType/businessContext/IJob_32";
import { IAPI_STA003_Request } from "../../type/apiType";
import { FormList } from "../../type/apiType/IAPI_STA008";
import _ from "lodash";
import { toNumberOrUndefined } from "../../utils/useTools";

/**
 * SCRC060026 退職情報　登録（登録内容の確認）
 * @return SCRC060026 退職情報　登録（登録内容の確認）
 */
const SCRC060026 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [stateInfoList, setStateInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const isSetContextApplyId = location?.state?.applyId;

  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  // 持回情報
  const { state: businessState } = useContext(BusinessContext);
  // ユーザタイプ
  const userType = state?.authInfo?.userType;
  const dataInfo = businessState.job_32;
  const fileDataInfo = businessState.job_32?.formList;

  const [fileBase64Ledger, setFileBase64Ledger] = useState<string>("");
  const [lAStatus, setLAStatus] = useState<boolean>(false);
  const [kikoButton, setkikoButton] = useState<boolean>(true);
  const [lAdis, setLADis] = useState<boolean>(false);
  const [disRepDia, setDisRepDia] = useState<boolean>(false);
  const [disMessDia, setDisMessDia] = useState<boolean>(false);
  const [ckecked, setCkecked] = useState<boolean>(false);
  const [linkDisabled, setLinkDisabled] = useState<boolean>(false);
  const applyId = location.state?.applyId ?? businessState.job_32?.applyId;
  const stepFlg = location.state?.stepFlg;
  const ckeckedShowFlgRef = useRef<boolean>(false);

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //取得した持ち回り情報orAPIのレスポンスを入出力項目にセットする
  const handleSetInitItem = (
    res?: any,
    resDataInfo?: any,
    isSetContextApplyId?: boolean
  ) => {
    let resArr = stateFakeTableList.current;

    // 職員番号
    resArr.find((item) => item.keyword === "staffNo")!.text = res?.staffNo;

    // 退職者名（新）
    const staffNameKanjiInput = resArr.find(
      (item) => item.keyword === "staffNameKanji"
    )!;
    // 退職者名カナ（新）
    const staffNameKanaInput = resArr.find(
      (item) => item.keyword === "staffNameKana"
    )!;
    // 退職者名漢字
    const bNameKanjiInput = resArr.find(
      (item) => item.keyword === "bNameKanji"
    )!;
    // 退職者名カナ
    const bNameKanaInput = resArr.find((item) => item.keyword === "bNameKana")!;

    if (res?.bNameKanji) {
      staffNameKanjiInput.text = res?.staffNameKanji;
      bNameKanjiInput.text = res?.bNameKanji;
    } else {
      staffNameKanjiInput.showLine = false;
      bNameKanjiInput.text = res?.staffNameKanji;
    }

    if (res?.bNameKana) {
      staffNameKanaInput.text = res?.staffNameKana;
      bNameKanaInput.text = res?.bNameKana;
    } else {
      staffNameKanaInput.showLine = false;
      bNameKanaInput.text = res?.staffNameKana;
    }

    // 退職者生年月日
    resArr.find((item) => item.keyword === "birthday")!.text = res?.birthday;

    // 退職者加入年月日
    resArr.find((item) => item.keyword === "firstJoinDate")!.text =
      res?.firstJoinDate;

    // 退職年月日
    resArr.find((item) => item.keyword === "retireDate")!.text =
      res?.retireDate;

    // 退職理由
    resArr.find((item) => item.keyword === "retireReason")!.text = `${TkGetCode(
      RetireReason,
      res?.nRetireReasonCd
    )}`;

    // 退職手続きの理由
    resArr.find(
      (item) => item.keyword === "retireProcedureReason"
    )!.text = `${TkGetCode(
      RetireFlowReason,
      res?.retireProcedureReason ?? ""
    )}`;

    // 退職者郵便番号
    resArr.find((item) => item.keyword === "zipcode")!.text =
      changeZipcodeFormat(res?.zipcode);

    // 退職者住所
    resArr.find((item) => item.keyword === "address")!.text = `${TkGetCode(
      Prefectures,
      res?.prefectureCd
    )}${res?.addressCity}${res?.addressOthers}`;

    // 退職者電話番号
    resArr.find((item) => item.keyword === "tel")!.text = res?.tel;

    // 退職年度のならない月

    let exclusionMonth = resArr.find(
      (item) => item.keyword === "exclusionMonth"
    )!;
    let checkedMonth: any = [];
    exclusionMonth.checkBoxList?.forEach((item) => {
      if (isSetContextApplyId) {
        let contextMonth = res?.[item.key as keyof IAPI_STA003_Request];
        if (contextMonth === "1" || contextMonth === "3") {
          checkedMonth.push(item.label);
        }
      } else {
        let contextMonth = res?.[item.key as keyof IJob_32Props];
        if (contextMonth === "1" || contextMonth === "3") {
          checkedMonth.push(item.label);
        }
      }
    });
    if (!checkedMonth.length) checkedMonth = ["無"];
    exclusionMonth.setDefaultValue = checkedMonth;

    resArr.find((item) => item.keyword === "childcareLeaveInfo")!.node = (
      <Box className="node">
        <TkTable
          headList={infoHeadTitleList}
          bodyList={funInfoBodyList(
            dataInfo
              ? businessState.job_32?.childcareLeaveRegistrationInfo
                  ?.childcareLeaveInfoList
              : res.childcareLeaveList
          )}
        />
      </Box>
    );
    resArr.find((item) => item.keyword === "childcareActiveListList")!.node = (
      <Box className="node">
        <TkTable
          headList={headListWorkingDayNum}
          bodyList={funWorkingDayNumInfoBodyList(
            dataInfo
              ? businessState.job_32?.childcareLeaveRegistrationInfo
                  ?.childcareActiveListList
              : res.childcareLeaveWorkingDayNumList
          )}
        />
      </Box>
    );

    resArr.find((item) => item.keyword === "salaryInfo")!.node = (
      <Box className="node">
        <TkTable
          headList={infoHeadTitleTwoList}
          bodyList={funInfoBodyTwoList(res)}
          headerLeftComponent={<Typography>俸給状況</Typography>}
        />
      </Box>
    );

    // 添付書類
    let retireReasonForFile = resArr.find(
      (item) => item.keyword === "retireReasonForFile"
    )!;
    retireReasonForFile.text = `${TkGetCode(
      RetireReason,
      res?.nRetireReasonCd
    )}`;

    const hasWageLedger = res?.formList?.some(
      (i: any) => i.formClass === FormClassRetire["賃金台帳"]
    );
    const hasEmploymentContract = res?.formList?.some(
      (i: any) => i.formClass === FormClassRetire["雇用契約書"]
    );

    const isRegularRetire = res?.nRetireReasonCd === RetireReason["普通退職"];

    resArr.forEach((item: ITkFakeTableLineProps) => {
      let targetFile = res?.formList?.find(
        (i: any) => i.formClass === item.keyword
      );
      if (targetFile) {
        item.dataname = targetFile?.formName ?? targetFile?.fileName;
        item.base64filedata = targetFile?.fileBase64;
      }

      if (
        (res?.retireProcedureReason === item.id ||
          dataInfo?.nRetireReasonCd === item.id) &&
        !(isRegularRetire && (!hasWageLedger || !hasEmploymentContract))
      ) {
        item.showLine = true;
      }

      if (isRegularRetire && item.keyword === "retireReasonForFile") {
        item.showLine = false;
      }
      if (item.id === RetireReason["犯罪等による退職"]) {
        item.showLine = res.nRetireReasonCd === item.id;
      }

      if (
        item.keyword === FormClassRetire["賃金台帳"] ||
        item.keyword === FormClassRetire["雇用契約書"]
      ) {
        item.showLine = !!targetFile;
      }
    });

    if (isRegularRetire && !hasWageLedger) {
      resArr.find((item) => item.keyword === "lineTitleFile")!.showLine = false;
    }

    // 福祉医療機構以外からの退職金受け取りの有無
    resArr.find(
      (item) => item.keyword === "prefectureRetirementJoinFlg"
    )!.text = TkGetCode(OtherBenefitsFlg, res?.prefectureRetirementJoinFlg);

    // 退職金請求の順番
    resArr.find((item) => item.keyword === "retirementInvoiceOrder")!.text =
      TkGetCode(
        RetirementInvoiceOrder,
        isSetContextApplyId
          ? res.retirementInvoiceOrder
          : res?.retirementRequestOrder
      );

    // 退職所得の源泉徴収票
    resDataInfo?.forEach((item: any) => {
      if (item.formKbn === "6" && item.formClass === "7") {
        resArr.find((item) => item.keyword === "page1Withholding")!.dataname =
          item.formName;
        resArr.find(
          (item) => item.keyword === "page1Withholding"
        )!.base64filedata = item.fileBase64;
      }
    });

    // 区分
    resArr.find((item) => item.keyword === "page1Kbn")!.text = TkGetCode(
      WithholdingSlipKbn,
      res?.page1Kbn
    );
    // 支払金額
    resArr.find((item) => item.keyword === "page1PaymentAmt")!.text =
      changeFormat(res?.page1PaymentAmt, "amount");
    // 源泉徴収額
    resArr.find((item) => item.keyword === "page1WithholdingAmt")!.text =
      changeFormat(res?.page1WithholdingAmt, "amount");
    // 特別徴収税額：市町村民税
    resArr.find((item) => item.keyword === "page1ScAmtCity")!.text =
      changeFormat(res?.page1ScAmtCity, "amount");
    // 特別徴収税額：都道府県税
    resArr.find((item) => item.keyword === "page1ScAmtPrefecture")!.text =
      changeFormat(res?.page1ScAmtPrefecture, "amount");
    // 勤続年数
    resArr.find((item) => item.keyword === "page1LengthOfService")!.text =
      changeFormat(res?.page1LengthOfService, "year");
    // 就職年月日
    resArr.find((item) => item.keyword === "page1EmployedDate")!.text =
      res?.page1EmployedDate;
    // 退職年月日
    resArr.find((item) => item.keyword === "page1RetiredDate")!.text =
      res?.page1RetiredDate;
    // 控除期間（年）（１枚目）
    resArr.find((item) => item.keyword === "page1DeductionPeriodYear")!.text =
      changeFormat(res?.page1DeductionPeriodYear, "year");
    // 控除期間（月）（１枚目）
    resArr.find((item) => item.keyword === "page1DeductionPeriodMonth")!.text =
      changeFormat(res?.page1DeductionPeriodMonth, "month");

    resArr.forEach(
      (item) => item.id === "page2" && (item.showLine = !!res?.page2Kbn)
    );
    // 退職所得の源泉徴収票 2枚目
    resDataInfo?.forEach((item: any) => {
      if (item.formKbn === "6" && item.formClass === "39") {
        resArr.find((item) => item.keyword === "page2Withholding")!.dataname =
          item.formName;
        resArr.find(
          (item) => item.keyword === "page2Withholding"
        )!.base64filedata = item.fileBase64;
      }
    });
    // 区分 2枚目
    resArr.find((item) => item.keyword === "page2Kbn")!.text = TkGetCode(
      WithholdingSlipKbn,
      res?.page2Kbn
    );
    // 支払金額 2枚目
    resArr.find((item) => item.keyword === "page2PaymentAmt")!.text =
      changeFormat(res?.page2PaymentAmt, "amount");
    // 源泉徴収額 2枚目
    resArr.find((item) => item.keyword === "page2WithholdingAmt")!.text =
      changeFormat(res?.page2WithholdingAmt, "amount");
    // 特別徴収税額：市町村民税 2枚目
    resArr.find((item) => item.keyword === "page2ScAmtCity")!.text =
      changeFormat(res?.page2ScAmtCity, "amount");
    // 特別徴収税額：都道府県税 2枚目
    resArr.find((item) => item.keyword === "page2ScAmtPrefecture")!.text =
      changeFormat(res?.page2ScAmtPrefecture, "amount");
    // 勤続年数 2枚目
    resArr.find((item) => item.keyword === "page2LengthOfService")!.text =
      changeFormat(res?.page2LengthOfService, "year");
    // 就職年月日 2枚目
    resArr.find((item) => item.keyword === "page2EmployedDate")!.text =
      res?.page2EmployedDate;
    // 退職年月日 2枚目
    resArr.find((item) => item.keyword === "page2RetiredDate")!.text =
      res?.page2RetiredDate;
    // 控除期間（年）（２枚目）
    resArr.find((item) => item.keyword === "page2DeductionPeriodYear")!.text =
      changeFormat(res?.page2DeductionPeriodYear, "year");
    // 控除期間（月）（２枚目）
    resArr.find((item) => item.keyword === "page2DeductionPeriodMonth")!.text =
      changeFormat(res?.page2DeductionPeriodMonth, "month");

    resArr.forEach(
      (item) => item.id === "page3" && (item.showLine = !!res?.page3Kbn)
    );
    // 退職所得の源泉徴収票 3枚目
    resDataInfo?.forEach((item: any) => {
      if (item.formKbn === "6" && item.formClass === "40") {
        resArr.find((item) => item.keyword === "page3Withholding")!.dataname =
          item.formName;
        resArr.find(
          (item) => item.keyword === "page3Withholding"
        )!.base64filedata = item.fileBase64;
      }
    });
    // 区分 3枚目
    resArr.find((item) => item.keyword === "page3Kbn")!.text = TkGetCode(
      WithholdingSlipKbn,
      res?.page3Kbn
    );
    // 支払金額 3枚目
    resArr.find((item) => item.keyword === "page3PaymentAmt")!.text =
      changeFormat(res?.page3PaymentAmt, "amount");
    // 源泉徴収額 3枚目
    resArr.find((item) => item.keyword === "page3WithholdingAmt")!.text =
      changeFormat(res?.page3WithholdingAmt, "amount");
    // 特別徴収税額：市町村民税 3枚目
    resArr.find((item) => item.keyword === "page3ScAmtCity")!.text =
      changeFormat(res?.page3ScAmtCity, "amount");
    // 特別徴収税額：都道府県税 3枚目
    resArr.find((item) => item.keyword === "page3ScAmtPrefecture")!.text =
      changeFormat(res?.page3ScAmtPrefecture, "amount");
    // 勤続年数 3枚目
    resArr.find((item) => item.keyword === "page3LengthOfService")!.text =
      changeFormat(res?.page3LengthOfService, "year");
    // 就職年月日 3枚目
    resArr.find((item) => item.keyword === "page3EmployedDate")!.text =
      res?.page3EmployedDate;
    // 退職年月日 3枚目
    resArr.find((item) => item.keyword === "page3RetiredDate")!.text =
      res?.page3RetiredDate;
    // 控除期間（年）（３枚目）
    resArr.find((item) => item.keyword === "page3DeductionPeriodYear")!.text =
      changeFormat(res?.page3DeductionPeriodYear, "year");
    // 控除期間（月）（３枚目）
    resArr.find((item) => item.keyword === "page3DeductionPeriodMonth")!.text =
      changeFormat(res?.page3DeductionPeriodMonth, "month");

    if (res?.latestApplyStatus) {
      const statusCodes = [
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
      ];

      if (statusCodes.includes(res?.latestApplyStatus)) {
        setLAStatus(true);
        resDataInfo?.forEach((item: any) => {
          if (item.formClass === "RPT0701019") {
            setFileBase64Ledger(item.fileBase64 ?? "");
            setLADis(true);
            if (!item.fileBase64) {
              setLinkDisabled(true);
            }
          }
        });
      }
    }

    setStateInfoList([...resArr]);
  };

  const changeFormat = (value: any, type: "amount" | "year" | "month") => {
    let formattedValue = "";
    if (value) {
      switch (type) {
        case "amount":
          formattedValue = changeAmountFormat(value) + "円";
          break;
        case "year":
          formattedValue = value + "年";
          break;
        case "month":
          formattedValue = value + "月";
          break;
      }
    }
    return formattedValue;
  };

  // 初期表示
  const handleInit = async () => {
    if (isSetContextApplyId) {
      try {
        const res = await httpAPI_STA003({
          contractorNo: state.authInfo?.contractorNo,
          applyId: applyId,
        });
        if (res.resultCd === "I0000") {
          setkikoButton(false);
          handleSetInitItem(res, res.formList, isSetContextApplyId);
          ckeckedShowFlgRef.current = false;
          setState({
            ...state,
            errorMsgId: "",
          });
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
    } else {
      handleSetInitItem(dataInfo, fileDataInfo, isSetContextApplyId);
      ckeckedShowFlgRef.current = true;
    }
  };

  const handSubmission = async (date?: any) => {
    let contractNo =
      userType === authorityUserType.userTypeNumber.KIKO
        ? businessState.common?.contractorNo
        : state.authInfo?.contractorNo;

    try {
      const formList: FormList[] =
        dataInfo?.formList?.map((obj) => {
          let newObj: any = { ...obj };
          newObj.formStatus = obj.attachDocRegStatus;
          delete newObj.attachDocRegStatus;
          return newObj;
        }) || [];

      /**
       * 1.入出力項目.退職理由コード=1以外の場合
       * 　"JOB-31"を設定
       * 2.入出力項目.退職理由コード=1かつ
       * 　入出力項目.退職手続きの理由=法人都合かつ
       * 　　持回情報.継続異動該当条件１フラグ=1かつ
       * 　　　持回情報.継続異動該当条件２フラグ=1の場合
       * 　"JOB-33"を設定
       * 3.上記以外の場合
       * 　"JOB-32"を設定
       */
      const job_32 = businessState.job_32;
      let businessType = "JOB-32";
      if (job_32?.nRetireReasonCd !== RetireReason["普通退職"]) {
        businessType = "JOB-31";
      }
      if (
        job_32?.nRetireReasonCd === RetireReason["普通退職"] &&
        job_32?.retireProcedureReason ===
          RetireFlowReason["法人（業務上の）都合"] &&
        job_32?.continueTransferApplicable1Flg === "1" &&
        job_32?.continueTransferApplicable2Flg === "1"
      ) {
        businessType = "JOB-33";
      }
      const param = API_STA008_BuildReqParams({
        contractorNo: contractNo, //共済契約者番号
        applyId: applyId, //申請id
        businessType: businessType, // 業務タイプ
        staffNo: dataInfo?.staffNo ?? "", //法人職員番号
        staffNameKanji: dataInfo?.staffNameKanji ?? "", //法人職員氏名（漢字）
        staffNameKana: dataInfo?.staffNameKana ?? "", //法人職員氏名（ｶﾅ）
        BNameKanji: dataInfo?.bNameKanji, //変更前氏名（漢字）
        BNameKana: dataInfo?.bNameKana, //変更前氏名ｶﾅ
        birthday: dataInfo?.birthday ?? "", //法人職員生年月日
        sex: dataInfo?.sex ?? "", //法人職員性別
        jobCd: dataInfo?.jobCd ?? "", //職種番号
        retireReasonCd: dataInfo?.nRetireReasonCd ?? "", //退職理由コード
        retireProcedureReason: dataInfo?.retireProcedureReason, //退職手続きの理由
        prefectureRetirementJoinFlg: dataInfo?.prefectureRetirementJoinFlg, //都道府県の退職金制度への加入有無
        retirementRequestOrderFlg: dataInfo?.retirementRequestOrder, //退職金請求の順番
        firstJoinDate: dataInfo?.firstJoinDate ?? "", //初回加入年月日
        changedName: dataInfo?.staffNameKanji, //変更後氏名（漢字）
        changedNameKana: dataInfo?.staffNameKana, //変更後氏名ｶﾅ
        retireDate: dataInfo?.retireDate ?? "", //退職年月日
        zipcode: dataInfo?.zipcode ?? "", //退職者住所（郵便番号）
        prefectureCd: businessState.job_32?.prefectureCd ?? "", //退職者住所（都道府県）
        addressCity: dataInfo?.addressCity ?? "", //退職者住所（市区町村）
        addressOthers: dataInfo?.addressOthers, //退職者住所（その他））
        tel: dataInfo?.tel ?? "", //退職者電話番号
        year: dataInfo?.year ?? 0, //年度
        apr: dataInfo?.apr ?? "", //4月
        may: dataInfo?.may ?? "", //5月
        jun: dataInfo?.jun ?? "", //6月
        jul: dataInfo?.jul ?? "", //7月
        aug: dataInfo?.aug ?? "", //8月
        sep: dataInfo?.sep ?? "", //9月
        oct: dataInfo?.oct ?? "", //10月
        nov: dataInfo?.nov ?? "", //11月
        dec: dataInfo?.dec ?? "", //12月
        jan: dataInfo?.jan ?? "", //1月
        feb: dataInfo?.feb ?? "", //2月
        mar: dataInfo?.mar ?? "", //3月
        page1Kbn: dataInfo?.page1Kbn, // 特別徴収票の区分
        page1PaymentAmt: dataInfo?.page1PaymentAmt, // 支払金額
        page1WithholdingAmt: dataInfo?.page1WithholdingAmt, // 源泉徴収額
        page1ScAmtCity: dataInfo?.page1ScAmtCity, // 特別徴収税額（市町村民税）
        page1ScAmtPrefecture: dataInfo?.page1ScAmtPrefecture, // 特別徴収税額（道府県民税）
        page1LengthOfService: dataInfo?.page1LengthOfService, // 勤続年数
        page1EmployedDate: dataInfo?.page1EmployedDate, // 就職年月日
        page1RetiredDate: dataInfo?.page1RetiredDate, // 退職年月日
        page1DeductionPeriodYear: toNumberOrUndefined(
          dataInfo?.page1DeductionPeriodYear
        ), // 控除期間（年）
        page1DeductionPeriodMonth: toNumberOrUndefined(
          dataInfo?.page1DeductionPeriodMonth
        ), // 控除期間（月）

        // 2枚目の情報
        page2Kbn: dataInfo?.page2Kbn, // 特別徴収票の区分
        page2PaymentAmt: dataInfo?.page2PaymentAmt, // 支払金額
        page2WithholdingAmt: dataInfo?.page2WithholdingAmt, // 源泉徴収額
        page2ScAmtCity: dataInfo?.page2ScAmtCity, // 特別徴収税額（市町村民税）
        page2ScAmtPrefecture: dataInfo?.page2ScAmtPrefecture, // 特別徴収税額（道府県民税）
        page2LengthOfService: dataInfo?.page2LengthOfService, // 勤続年数
        page2EmployedDate: dataInfo?.page2EmployedDate, // 就職年月日
        page2RetiredDate: dataInfo?.page2RetiredDate, // 退職年月日
        page2DeductionPeriodYear: dataInfo?.page2DeductionPeriodYear, // 控除期間（年）
        page2DeductionPeriodMonth: dataInfo?.page2DeductionPeriodMonth, // 控除期間（月）

        // 3枚目の情報
        page3Kbn: dataInfo?.page3Kbn, // 特別徴収票の区分
        page3PaymentAmt: dataInfo?.page3PaymentAmt, // 支払金額
        page3WithholdingAmt: dataInfo?.page3WithholdingAmt, // 源泉徴収額
        page3ScAmtCity: dataInfo?.page3ScAmtCity, // 特別徴収税額（市町村民税）
        page3ScAmtPrefecture: dataInfo?.page3ScAmtPrefecture, // 特別徴収税額（道府県民税）
        page3LengthOfService: dataInfo?.page3LengthOfService, // 勤続年数
        page3EmployedDate: dataInfo?.page3EmployedDate, // 就職年月日
        page3RetiredDate: dataInfo?.page3RetiredDate, // 退職年月日
        page3DeductionPeriodYear: dataInfo?.page3DeductionPeriodYear, // 控除期間（年）
        page3DeductionPeriodMonth: dataInfo?.page3DeductionPeriodMonth, // 控除期間（月）

        formList, //帳票情報リスト
        aContractorNo: dataInfo?.aContractorNo, //異動後共済契約者番号
        aContractorName: dataInfo?.aCorpName, //異動後共済契約者名
        formProspectNum: dataInfo?.withholdingTaxSlipTotal, //源泉徴収票登録枚数
        transferDate: dataInfo?.transferDate, //異動年月日
        continueTransferApplicable1Flg:
          dataInfo?.continueTransferApplicable1Flg, //継続異動該当条件1フラグ
        continueTransferApplicable2Flg:
          dataInfo?.continueTransferApplicable2Flg, //継続異動該当条件2フラグ
        receptionDate: date, //受付日
        contracterAllowanceRequestFlg: ckecked ? "1" : "0", //契約者が手当金請求を行うフラグ
        updateDateTime: dataInfo?.updateDateTime ?? "", //更新日時
        sixMonthsSalaryBeforeApplyList:
          dataInfo?.sixMonthsSalaryBeforeApplyList!, //申請前6か月間の本俸月額リスト
        sixMonthsSalaryBeforeApplyDetailList:
          dataInfo?.sixMonthsSalaryBeforeApplyDetailList!, //申請前6か月本俸月額の調整額明細リスト
        screenId: "SCRC060026", //画面ID
      });
      const res = await httpIAPI_STA008(param);
      if (res.resultCd === "I0000") {
        setState({ ...state, errorMsgId: "" });
        if (ckecked) {
          if (userType === authorityUserType.userTypeNumber.DAIKOSHA) {
            navigate("/SCRC070008");
          } else {
            res.transferCd ? navigate("/SCRR411102") : navigate("/SCRC070008");
          }
        } else if (res.transferCd) {
          navigate("/SCRC060129", {
            state: { applyId: businessState?.retirement?.applyId },
          });
        } else {
          navigate("/SCRC070008");
        }
      } else {
        setDisRepDia(false);
        setDisMessDia(false);
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onClickSubmit = () => {
    if (userType === authorityUserType.userTypeNumber.KIKO) {
      setDisRepDia(true);
    } else {
      setDisMessDia(true);
    }
  };

  return (
    <Box data-testid="SCRC060026PageForTest" className="SCRC060026">
      <TkStepper steps={stepper} activeStep={stepFlg ? 7 : 6} />
      <Box className="SCRC060026InfoManualTop">
        <Typography className="fontText">
          {spaceArea}
          {conTop}
        </Typography>
      </Box>
      <Box>
        <TkInfoManual rule={"\\n"}>{conMid}</TkInfoManual>
      </Box>
      {userType === authorityUserType.userTypeNumber.KIKO && (
        <Box>
          <TkContractorAndNumberLine
            name="契約者（法人）名"
            no={
              businessState.common?.contractorNo +
              ":" +
              businessState.common?.contractorName
            }
          />
        </Box>
      )}
      <Box>
        <TkFakeTable list={stateInfoList} ruleSchema={{}} showButton={false} />
      </Box>
      {ckeckedShowFlgRef.current && (
        <Box className="checkTitle">
          <Typography>{context}</Typography>
          <TkCheckbox
            label="はい"
            checked={ckecked}
            onChange={() => setCkecked(!ckecked)}
          />
        </Box>
      )}
      {lAStatus && (
        <Box>
          <Typography>帳票名</Typography>
          {lAdis && (
            <TkDownloadLink
              dataname={"被共済職員退職届"}
              base64filedata={fileBase64Ledger}
              downloadBase64={true}
              linkDisabled={linkDisabled}
            />
          )}
        </Box>
      )}
      <Box className="SCRC060026Button">
        <TkBackButton />
        {kikoButton && (
          <TkButton onClick={onClickSubmit}>
            {userType === authorityUserType.userTypeNumber.KIKO
              ? "申請"
              : "機構へ提出する"}
          </TkButton>
        )}
      </Box>
      <TkDateDialog
        open={disRepDia}
        onOky={handSubmission}
        onCancel={() => setDisRepDia(false)}
        requeried={true}
        minDate={new Date("1900/01/01")}
        maxDate={new Date()}
        title="確認（申請を行います）"
        contextText="申請を行いますが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />
      <TkMessageDialog
        open={disMessDia}
        onOky={handSubmission}
        onCancel={() => {
          setDisMessDia(false);
        }}
        title="確認（機構へ提出する）"
        contextText="機構へ提出を行いますが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRC060026;
